<template>
  <div class="swimlanes-wrap">
    <div class="flex flex-row">
      <div
        v-for="(mainList, index) in props.mainListIds"
        :key="index"
        class="flex flex-row"
        :class="{
          'empty-group': isMainListEmpty(mainList),
        }"
      >
        <BoardListHeader
          :list-id="String(mainList)"
          :header-footer-style="{}"
          :expandable="false"
          :show-status-icon-picker="showStatusIconPickerMainGroup"
          :disable-status-icon-picker="true"
          :group-by="boardGroupBy"
          :list-cards="getMainListCards(mainList)"
          :visible="true"
          :is-cards-layout-timeline="false"
          :is-epic-board="false"
          :is-main-group="true"
        />
      </div>
    </div>
    <div class="child-lists flex flex-col">
      <div
        v-for="subGroupList in subGroupByObject.order || []"
        :key="subGroupList"
        class="flex flex-col"
      >
        <SwimlanesList
          :list-id="subGroupList"
          :main-list-ids="props.mainListIds"
          :max-displayed-lists="props.maxDisplayedLists"
          :position="props.position"
          :container-width="props.containerWidth"
          :empty-main-lists="emptyMainListIds"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useSwimlanes from '../../boards/composables/useSwimlanes';
import BoardListHeader from '@/components/widgets/BoardListHeader.vue';
import SwimlanesList from '@/components/widgets/SwimlanesList.vue';
import { computed } from 'vue';

const { boardGroupBy, showStatusIconPickerMainGroup, subGroupByObject, hideEmptyGroups } =
  useSwimlanes();

const props = defineProps({
  mainListIds: {
    type: Array,
    required: true,
  },
  maxDisplayedLists: {
    type: Number,
    default: 4,
  },
  position: {
    type: Number,
    required: false,
    default: 0,
  },
  containerWidth: {
    type: Number,
    required: false,
    default: 0,
  },
  visibleListIds: {
    type: Function,
    required: false,
    default: () => [],
  },
});

const getMainListCards = (listId: unknown) => {
  const safeListId = String(listId);
  const listCards: string[] = [];
  if (subGroupByObject.value && subGroupByObject.value.order) {
    for (const subListId of subGroupByObject.value.order) {
      listCards.push(...(subGroupByObject.value[safeListId]?.[subListId]?.cardIds || []));
    }
  }
  return listCards;
};

// Check if a main list is empty (has no cards)
const isMainListEmpty = (mainListId: unknown) => {
  if (!hideEmptyGroups.value) {
    return false;
  }

  const cards = getMainListCards(mainListId);
  return cards.length === 0;
};

// Computed property to get the list of empty main list IDs
const emptyMainListIds = computed(() => {
  if (!hideEmptyGroups.value) {
    return [];
  }

  return (props.mainListIds as Array<unknown>)
    .filter((mainListId) => {
      return isMainListEmpty(mainListId);
    })
    .map((id) => String(id));
});
</script>

<style lang="scss">
.swimlanes-wrap {
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: calc(100vh - 100px);
  padding: 12px;

  .empty-group {
    flex-basis: 0 !important;
    min-width: 0;
    > * {
      display: none;
    }
  }
}
</style>
